var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleXmarkOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uxlq8ritca)",
    fill: "#000",
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.468 11.646a.322.322 0 0 0-.321-.321l-2.652.012-3.994 4.76-3.99-4.756-2.655-.012a.32.32 0 0 0-.322.321c0 .076.028.149.077.21l5.227 6.227-5.227 6.223a.322.322 0 0 0 .245.53l2.656-.011 3.99-4.761 3.99 4.757 2.65.012a.32.32 0 0 0 .322-.322.334.334 0 0 0-.076-.209l-5.22-6.223 5.228-6.228a.323.323 0 0 0 .072-.209z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.502 0c-9.94 0-18 8.06-18 18s8.06 18 18 18 18-8.06 18-18-8.06-18-18-18zm0 32.946c-8.253 0-14.946-6.693-14.946-14.946S10.249 3.054 18.502 3.054 33.448 9.747 33.448 18s-6.693 14.946-14.946 14.946z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uxlq8ritca"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.502)",
    d: "M0 0h36v36H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleXmarkOutlined);
export default __webpack_public_path__ + "static/media/circle-xmark-outlined.154c1097a8e3785e82576b8fba85a4a4.svg";
export { ForwardRef as ReactComponent };